import React, { useState } from "react"
import "./card-orders.scss"

import FormatDate from "../../../shared/utils/formartDate"
import formatNumber from "../../../shared/utils/formatNumber.js"
import Loader from "react-loader-spinner"

import MyPointsService from "../../../shared/services/my-points-service"
import { atCol } from "../../../constants/country.constants.js"
import descuentoSvg from "../../../assets/images/descuento.svg"

const CardOrders = props => {
  const { items } = props
  const [isShow, setIsShow] = useState(false)
  const handleHide = e => {
    e.preventDefault()
    setIsShow(!isShow)
  }
  const [loadPdf, setloadPdf] = useState(false)

  const handleDownLoadPdf = e => {
    setloadPdf(true)
    e.preventDefault()
    e.stopPropagation()
    var tokenId = JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken

    var config = {
      responseType: "blob",
      headers: {
        Authorization: tokenId,
      },
    }

    MyPointsService.downLoadPdf(items.redemptionId, config)
      .then(res => {
        const file = new Blob([res.data], { type: "application/pdf" })
        const fileURL = window.URL.createObjectURL(file)
        const link = document.createElement("a")
        link.href = fileURL
        link.download = "Redencion.pdf"
        link.click()
        setloadPdf(false)
      })
      .catch(err => {
        console.log(err)
        setloadPdf(false)
      })
  }
  return (
    <div
      className="f-mypoints-result-search-orders"
      onClick={e => handleHide(e)}
    >
      <div className="f-mypoints-result-search-orders-container">
        <div className="f-container-show">
          <div className="f-container-show-img">
            <img
              className="f-show-img"
              src="https://dev-portals-images.s3.amazonaws.com/NOL/products/camion.svg"
              alt=""
            />
          </div>
          <div className="f-container-show-info">
            <div className="f-info-name">
              <h6 className="f-info-name-title">Redención de premios</h6>
              <p>{items.order}</p>
              <p>{FormatDate(items.creationDate)}</p>
            </div>
            <div className="f-info-point">
              {!atCol && (
                <>
                  {loadPdf ? (
                    <Loader
                      type="TailSpin"
                      color="#FF409B"
                      height={25}
                      width={25}
                    />
                  ) : (
                    <p
                      onClick={e => {
                        handleDownLoadPdf(e)
                      }}
                      className="f-info-point-download-form"
                    >
                      Descargar formulario
                    </p>
                  )}
                </>
              )}

              <h6 className={"f-info-name-title"}>
                {formatNumber(items.points)} puntos
              </h6>
              <div className={"f-arrow"}>
                <div
                  className={
                    "f-arrow-container" + (isShow ? " f-arrow-effect" : "")
                  }
                >
                  <span className={"f-icon icon-down f-card-arrow"}></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        {items.prizes &&
          items.prizes.map((item, index) => {
            return (
              <div key={index}>
                <div
                  className={
                    `f-info-hide-container ` + (isShow ? "f-unhide" : "f-hide")
                  }
                >
                  <div className="f-container-img">
                    {atCol ? (
                      <img
                        style={{ width: "unset" }}
                        className="f-container-img-show"
                        src={descuentoSvg}
                        alt=""
                      />
                    ) : (
                      <img
                        className="f-container-img-show"
                        src={item.image}
                        alt=""
                      />
                    )}
                  </div>
                  <div className="f-info-hide-container-desc">
                    <div className="f-info-name">
                      <p className="f-title">{item.name}</p>
                      <p>{item.quantity} unidad</p>
                    </div>
                    <div className="f-info-points">
                      <p>{formatNumber(item.points)} puntos</p>
                    </div>
                  </div>
                </div>
                {isShow ? (
                  <div className="f-line-separate-container">
                    <div className="f-line"> </div>
                  </div>
                ) : null}
              </div>
            )
          })}
      </div>
    </div>
  )
}

export default CardOrders
